export default __webpack_public_path__ + "static/media/offline_downloading.ab822456.svg";